import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Trans } from '@lingui/macro';
import { map } from 'lodash';
import { MenuItem } from '@material-ui/core';
import NgpSelect from '../../../../../form/NgpSelect';
import {
    DEFAULT_DURATION,
    DEFAULT_RING_DURATION,
    SCHEDULED_CALL_DURATION_OPTIONS,
    SCHEDULED_RING_DURATION_OPTIONS,
    WITH_NO_PREFS_CODECS_KEY_VALUE,
} from '../../../../../panels/voip-test-now-panels/VoipTestConstants';
import { durationDisplayDefault } from '../../../../../panels/voip-test-now-panels/VoipPulseTestConfigHelpers';
import { useSettingStyles } from '../../../../../panels/voip-test-now-panels/VoipTestNowCallSettings';

export const CallSettingsFieldSection = () => {
    const classes = useSettingStyles();
    const { register } = useFormContext();

    // Register testConfig.jitter — required by the backend but has no UI input
    // in scheduled mode (portal/ui ng-if="testNow"). Registration preserves the
    // value from reset() for Copy/Edit flows; the submit transform provides a
    // default for Create. Registered here (not in UseVoipCallParticipants) so
    // it covers both VoipPulse and VoipPhone test types.
    useEffect(() => {
        register({ name: 'testConfig.jitter' });
    }, [register]);

    return (
        <>
            <div style={{ width: 400 }}>
                <NgpSelect
                    fieldName="testConfig.ringDuration"
                    label={<Trans>Ring Duration</Trans>}
                    required
                    className={classes.testSelect}
                >
                    {SCHEDULED_RING_DURATION_OPTIONS.map((ringDuration) => (
                        <MenuItem key={ringDuration} value={ringDuration}>
                            {durationDisplayDefault(ringDuration, DEFAULT_RING_DURATION)}
                        </MenuItem>
                    ))}
                </NgpSelect>
            </div>
            <div style={{ width: 400 }}>
                <NgpSelect
                    fieldName="testConfig.duration"
                    label={<Trans>Call Duration</Trans>}
                    required
                    className={classes.testSelect}
                >
                    {SCHEDULED_CALL_DURATION_OPTIONS.map((duration) => (
                        <MenuItem key={duration} value={duration}>
                            {durationDisplayDefault(duration, DEFAULT_DURATION)}
                        </MenuItem>
                    ))}
                </NgpSelect>
            </div>

            <div style={{ width: 400 }}>
                <NgpSelect
                    fieldName="testConfig.preferredCodec"
                    label={<Trans>Preferred Codec</Trans>}
                    required
                    className={classes.testSelect}
                >
                    {map(WITH_NO_PREFS_CODECS_KEY_VALUE, (value, key) => (
                        <MenuItem key={key} value={key}>
                            {value}
                        </MenuItem>
                    ))}
                </NgpSelect>
            </div>
        </>
    );
};
